<template>
	<div class="CarsEmailsView">				
		<p><a href="#!" id="syncMailsButton" class="button" v-on:click="getMails">E-Mails laden</a> &nbsp; <a href="#!" id="closeMails" class="button" v-on:click="closeMails">Alle einklappen</a><br>&nbsp;</p>
		<cars-email v-for="email in emails" :email.sync="email" :key="email.mail.messageId"></cars-email>
	</div>
</template>
<script>
	import CarsEmail from '@/components/Cars/CarsEmail';
	
export default {
  	name: 'CarsEmailsView',
	components: {
	    CarsEmail,
	},
	props: ['car'],
  	data() {
	  	return {
	      	emails: []
	  	}
	},
	sockets: {
		syncCarsEmails( obj ){
  		obj.open = false;
  		//console.log(obj);
			this.emails.push( obj );
			$('#syncMailsButton').text('aktualisieren');
		}
	},

	methods: {
		getMails(e){
			e.preventDefault();
			//console.log('start sync E-Mails for ' + this.$store.state.editingCarID );
			//console.log( this.car );
			this.emails = []
			$('#syncMailsButton').html('<i class="fa fa-spinner fa-pulse"></i>');
			this.$socket.emit('syncCarsEmails', { action: "getAll",  data: { vgn: this.car.vorgangsnummer, eml: this.car.e_mail } } );		
	  },
	  closeMails(e){
  	  //console.log(this.emails);
  	  this.emails.forEach(function(m,i){
    	  m.open = false;
    	  //console.log(i)
    	  //console.log(m)
  	  },this);
	  }
		
	},

	mounted: function(){
/*
			this.emails = []
			$('#syncMailsButton').html('<i class="fa fa-spinner fa-pulse"></i>');
			this.$socket.emit('syncCarsEmails', { action: "getAll",  data: { vgn: this.car.vorgangsnummer, eml: this.car.e_mail } } );		
*/
	}

}	
</script>
<style>
	.CarsEmailsView { border-bottom: 0 solid #ddd;}
	#syncMailsButton { min-width: 12em; }
</style>